import { crudFor } from "./dataClient";
import { seedEvents } from "@/data/seed/events";
import { isUpcoming } from "@/lib/format";

export const eventsCrud = crudFor("events", seedEvents);

export const eventsService = {
  async listEvents() {
    const rows = await eventsCrud.list((q) =>
      q.eq("is_published", true).order("event_date", { ascending: false })
    );
    return rows
      .filter((e) => e.is_published !== false)
      .sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
  },

  async listUpcoming(limit = 3) {
    const all = await this.listEvents();
    return all
      .filter((e) => isUpcoming(e.event_date))
      .sort((a, b) => new Date(a.event_date) - new Date(b.event_date))
      .slice(0, limit);
  },

  getEvent(slug) {
    return eventsCrud.getBy("slug", slug);
  },

  async listByUnit(unitSlug) {
    const all = await this.listEvents();
    return all.filter((e) => e.unit_slug === unitSlug);
  },

  async listByForum(forumSlug) {
    const all = await this.listEvents();
    return all.filter((e) => e.forum_slug === forumSlug);
  },
};
